import { render } from "./PlantDetail.vue?vue&type=template&id=3a5e9ff2&scoped=true&ts=true"
import script from "./PlantDetail.vue?vue&type=script&lang=ts"
export * from "./PlantDetail.vue?vue&type=script&lang=ts"

import "./PlantDetail.vue?vue&type=style&index=0&id=3a5e9ff2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5e9ff2"]])

export default __exports__